import { alpha } from "@mui/material/styles";

// プロジェクトで使用
export const PROJECT_COLOR = "#8859E4";
export const PROJECT_COLOR_LIGHT = "#AF6DDE";
export const PROJECT_COLOR_DARK = "#7748d6";

// 求人で使用
export const JOB_COLOR = "#474ECE";
export const JOB_COLOR_LIGHT = "#6D98DE";
export const JOB_COLOR_DARK = "#4951D0";

/**
 * 求人(job) / プロジェクト(project) で使用する共通カラーを返す関数。
 *
 * - job    → "#8859E4"
 * - project → "#474ECE"
 *
 * どのコンポーネントでも同じロジックを使えるように共通化している。
 */
export const getTypeColor = (type) => {
  return type === "job" ? JOB_COLOR : PROJECT_COLOR;
};

/**
 * 未読・既読に応じて使用するテキストカラーを返す
 */
export const getReadStatusColor = (theme, isNew) => {
  return isNew ? theme.palette.text.primary : theme.palette.text.secondary;
};

/**
 * スキルバッジで使用する色味セットを返す
 *
 * - bgStrong  : 強調表示（NEWなど）
 * - bgDefault : 通常表示
 * - textStrong: 強調テキスト
 * - textDefault  : 通常テキスト
 * - border    : 通常表示用ボーダー
 */
export const getSkillBadgeColorSet = (type) => {
  const baseColor = getTypeColor(type);

  return {
    base: baseColor,
    bgStrong: alpha(baseColor, 0.15),
    bgDefault: alpha(baseColor, 0.07),
    textStrong: baseColor,
    textDefault: alpha(baseColor, 0.7),
    border: `1px solid ${alpha(baseColor, 0.15)}`,
  };
};
